<template>
  <div>
    <TituloDialog>
      <template #titulo-lado-direito>
        <v-spacer />

        <div class="d-flex align-center pr-5">
          <div style="width: 250px">
            <RelatoriosAutocomplete
              v-model="relatorioSelecionado"
              hide-details
              outlined
              dense
              append-icon="mdi-chevron-down" />
          </div>

          <CarregadorDeArquivosInput
            class="ml-3"
            @cotacoes-para-analisar="cotacoes_para_analise = $event"
            @carregando_dados="carregando_dados = $event"
          />
        </div>
      </template>
    </TituloDialog>

    <TempleteConteudoDialog>
      <ProgressoCarregamentoFase v-if="carregando_dados" />
      <ListaDeProdutos v-else :cotacoes_para_analise="cotacoes_para_analise" @categorias-selecinadas="categorias_selecionadas = $event" />
    </TempleteConteudoDialog>

    <RodapeDialog
      :dados_gerar_relatorio="DADOS_GERAR_RELATORIO"
      @cancelar="cancelar"
      @resetar-dialog="resetarDialog($event)"
    />
  </div>
</template>

<script>
import TituloDialog from "../TituloDialog";
import RodapeDialog from "../RodapeDialog";
import TempleteConteudoDialog from "../ajudantes/TempleteConteudoDialog";
import ProgressoCarregamentoFase from "../ProgressoCarregamentoFase";
import RelatoriosAutocomplete from "../../../../compra/departamentos/carrinho/cotacao/RelatoriosAutocomplete";
import CarregadorDeArquivosInput from "../carregamentoDeArquivos/CarregadorDeArquivosInput";
import ListaDeProdutos from "./ListaDeProdutos";

export default {
  name: "AnaliseProdutosDaCotacao",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  components: {
    ListaDeProdutos,
    CarregadorDeArquivosInput,
    RelatoriosAutocomplete,
    ProgressoCarregamentoFase,
    TempleteConteudoDialog,
    RodapeDialog,
    TituloDialog
  },
  props: {
    modelValue: Object
  },
  data: () => ({
    carregando_dados: false,
    relatorioSelecionado: null,
    categorias_selecionadas: []
  }),
  computed: {
    DADOS_GERAR_RELATORIO() {
      return {
        cotacoes_para_analise: this.cotacoes_para_analise,
        categorias_selecionadas: this.categorias_selecionadas
      }
    },
    cotacoes_para_analise: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      },
    }
  },
  methods: {
    resetarDialog(evento) {
      this.$emit('resetar-dialog', evento);
    },
    cancelar() {
      this.$emit("fechar-dialog", {});
    }
  }
}
</script>

<style scoped>

</style>
